import { render, staticRenderFns } from "./MascotBanner.vue?vue&type=template&id=6937d944&scoped=true&"
import script from "./MascotBanner.vue?vue&type=script&lang=js&"
export * from "./MascotBanner.vue?vue&type=script&lang=js&"
import style0 from "./MascotBanner.vue?vue&type=style&index=0&id=6937d944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937d944",
  null
  
)

export default component.exports